export const ROUTE_NO_MATCH_AUTH = '/';
export const ROUTE_NO_MATCH_PROSPECT = '/';
export const ROUTE_NO_MATCH_UNAUTH = '/login';
export const AUTHORISED = 'authorised';
export const PROSPECT = 'prospect';
